<p class="font-bold">
  {{ facet.key }}
  <span (click)="showOptions = !showOptions"
    ><i
      class="pi pi-fw open"
      [ngClass]="{
        'pi-chevron-right': showOptions,
        'pi-chevron-left': !showOptions
      }"
    ></i
  ></span>
</p>

<ul *ngIf="showOptions">
  <li *ngFor="let option of facet.options; let i = index">
    <div class="grid justify-content-center">
      <div class="col">
        <p-checkbox
          [ngModel]="option.active"
          [binary]="true"
          (onChange)="handleFacetSelection(facet.key, option.value)"
        ></p-checkbox>

        {{ option.value }}
      </div>
      <div class="col-2 grey-facet-count text-right">
        {{ option.total }}
      </div>
    </div>
  </li>
</ul>
